export class WorldSliderControls {
  constructor(sliders) {
    if (!sliders) return
    this.sliders = sliders.filter((slider) => slider.container.dataset.world !== undefined)
    this.sliders.forEach((slider) => {
      if (slider.track.details.maxIdx < 1) return
      const { nav } = slider.container.dataset
      if (nav === undefined) return
      const controls = document.createElement('div')
      controls.className = 'p-world__slider__controls'
      slider.container.parentNode.appendChild(controls)
      const { navEl } = this.createNav(slider)
      controls.appendChild(navEl)
    })
  }
  createNav(slider) {
    const prevEl = this.createButton('-prev')
    const nextEl = this.createButton('-next')
    prevEl.addEventListener('click', () => slider.prev())
    nextEl.addEventListener('click', () => slider.next())
    const navEl = document.createElement('div')
    navEl.className = 'p-world__slider__nav'
    navEl.appendChild(prevEl)
    navEl.appendChild(nextEl)
    prevEl.disabled = slider.track.details.rel === 0
    slider.on('slideChanged', () => {
      prevEl.disabled = slider.track.details.rel === 0
      nextEl.disabled = slider.track.details.rel === slider.track.details.maxIdx
    })
    return {
      navEl,
      prevEl,
      nextEl,
    }
  }
  createButton(className) {
    const button = document.createElement('button')
    button.type = 'button'
    button.className = className
    button.innerHTML = '<i class="fal fa-arrow-right"></i>'

    return button
  }
}
